import React, { useMemo } from 'react';

import ErrorHandlingLayout from '@sharedCR/common/ErrorHandlingLayout';
import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { emptyMessageCellStyles } from '../../Content.styles';

const HistoryTable = ({ isLoading, data, isError, fetchData, config }) => {
  const formattedData = useMemo(() => {
    const configKeys = Object.keys(config);

    return data.length
      ? data
      : [
          {
            [configKeys[0]]: {
              position: 1,
              customStyles: emptyMessageCellStyles,
              colSpan: configKeys.length,
              content: <NoAvailableMessage className="empty-message-row" message="No results" />,
            },
          },
        ];
  }, [data, config]);

  return (
    <ErrorHandlingLayout isError={isError} onClick={fetchData}>
      <TableCDS
        isStickyHeader
        className="max-h-600"
        config={config}
        data={formattedData}
        isCustomDataDefinition={!data.length}
        isLoading={isLoading || isError}
        skeletonRows={3}
      />
    </ErrorHandlingLayout>
  );
};

HistoryTable.propTypes = {
  data: PropTypes.array.isRequired,
  isError: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  ...WithLoadingPropTypes,
};

export default withLoading(HistoryTable);
